export default {
    editingContact: {},
    selectedContacts: [],
    contacts: [],
    pagination: {
        from: 0,
        to: 0,
        total: 0,
        currentPage: 1,
        lastPage: 0,
    },
};
